const LoaderItem = () => (

    <div className="accordion-item">
      <div className="accordion-item-loader" aria-hidden={true}></div>
    </div>
)

export default LoaderItem